module.exports = __webpack_public_path__ + "img/logo.f897106b.png";